import { render } from "./AudienceHeaderSkeleton.vue?vue&type=template&id=2807fdd1&scoped=true"
import script from "./AudienceHeaderSkeleton.vue?vue&type=script&lang=js"
export * from "./AudienceHeaderSkeleton.vue?vue&type=script&lang=js"

import "./AudienceHeaderSkeleton.vue?vue&type=style&index=0&id=2807fdd1&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2807fdd1"]])

export default __exports__